import React, { useState, useEffect } from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import FaqSection from './section-components/faq';
import Footer from './global-components/footer';
import { SendMail } from '../request/apiRquest';
import { Button, message } from 'antd';
import ContactSection from './new-components/contactsection';
import { Helmet } from 'react-helmet';
import CallingButton from '../utils/CallingButton';
import Faqs from './section-components/faq';
import BlogContact from '../utils/blogContact';



const inputStyle = {
	backgroundColor: "#f5f5f5",
	border: "1px solid #ccc",
	borderRadius: "6px",
	padding: "12px",
	fontSize: "14px",
	width: "100%",
	marginBottom: "15px",
	color: "#333",
};

const Contact = () => {

	message.config({
		top: 100,
		//	duration: 2, 
	});

	const [loading, setLoading] = useState(false);
	const [maildata, setMailData] = useState({
		FromName: "",
		FromEmail: "",
		ContactNo: "",
		Message: "",
		Language: ""
	});




	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true)

		if (!maildata?.ContactNo && !maildata?.FromEmail) {
			message.warning("Please fill the contact details before submitting");
			setLoading(false);
		} else {

			try {
				//console.log(maildata, "submit data");

				await SendMail(maildata);
				message.success("Your message has been sent successfully!", 3)
				setMailData({
					FromName: "",
					FromEmail: "",
					ContactNo: "",
					Message: "",
				});
			} catch (error) {
				console.log(error);
				message.error("Failed to send your message. Please try again.", 4);
			} finally {
				setLoading(false);
			}
		}
	}

	const handleChangeInput = (e) => {
		const { name, value } = e.target;

		setMailData({ ...maildata, [name]: value });
	}

	return <div>
		<Helmet>
			<title>Contact Trinest Sky Real Estate | Dubai Property Experts</title>
			<meta name="description" content="Reach out to Trinest Sky Real Estate for expert help with off-plan properties and luxury homes in Dubai. Call, email, or message us today." />
			{/* <meta name="keywords" content="Dubai real estate, Trinest Sky, contact, property consultation, WhatsApp chat, real estate expert" /> */}
		</Helmet>
		<Navbar />
		<PageHeader headertitle="Contact" />
		<div className="contact-area pd-top-50 pd-bottom-65">
			<ContactSection />
			<div className="container">

				<div className="row">
					<div className="col-lg-12">
						<div className="contact-page-map">
							<iframe className="w-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.829631009257!2d55.26992347394876!3d25.208967331226575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6702e02ed9d5d273%3A0xd0b8d09c671ca8c0!2sTRINEST%20SKY%20REAL%20ESTATE!5e0!3m2!1sen!2sin!4v1747805591863!5m2!1sen!2sin" style={{ border: 0 }} allowFullScreen />

						</div>
					</div>



				</div>
				<div className="container py-5">
					<div className="row">
						{/* LEFT: Contact Info */}
						<div
							className="col-md-8 mb-4"
							style={{
								backgroundColor: "#fff",
								padding: "40px",
								borderRadius: "12px",
								fontSize: "16px",
								boxShadow: "0 4px 15px rgba(0,0,0,0.07)",
								lineHeight: "1.8",
							}}
						>
							<h4 className="fw-bold mb-4" style={{ color: "#333", fontSize: "22px" }}>
								Trinest Sky Real Estate
							</h4>

							{/* Address */}
							<div className="d-flex align-items-start mb-4">
								<i className="fa fa-map-marker" style={{ color: "#FDA94F", fontSize: "22px", minWidth: "30px" }}></i>
								<p className="mb-0 text-muted ms-2">
									Aspin Commercial Tower, 4302F,<br />
									106 Sheikh Zayed Rd,<br />
									Trade Centre 1, Dubai
								</p>
							</div>

							{/* Phone */}
							<div className="d-flex align-items-start mb-4">
								<i className="fa fa-phone" style={{ color: "#FDA94F", fontSize: "20px", minWidth: "30px" }}></i>
								<p className="mb-0 text-muted ms-2">056 860 0147</p>
							</div>

							{/* Email */}
							<div className="d-flex align-items-start mb-4">
								<i className="fa fa-envelope" style={{ color: "#FDA94F", fontSize: "20px", minWidth: "30px" }}></i>
								<div className="text-muted ms-2">
									<div>ifo@trinestsky.com</div>
									<div>sr@trinestsky.com</div>
								</div>
							</div>

							{/* Buttons Row */}
							<div className="d-flex flex-wrap mt-3" style={{ gap: "20px" }}>
								{/* WhatsApp Button */}
								<a
									href="https://wa.me/045771575"
									target="_blank"
									rel="noopener noreferrer"
									className="btn d-inline-flex align-items-center"
									style={{
										backgroundColor: "#FDA94F",
										color: "white",
										fontWeight: "600",
										fontSize: "16px",
										padding: "10px 24px",
										borderRadius: "30px",
										textDecoration: "none",
									}}
								>
									<i className="fa fa-whatsapp me-2" style={{ fontSize: "20px" }}></i>
									Chat with us Instantly
								</a>

								{/* Call Us Button */}
								<a
									href="tel:+045771575"
									className="btn d-inline-flex align-items-center"
									style={{
										backgroundColor: "#FDA94F",
										color: "white",
										fontWeight: "600",
										fontSize: "16px",
										padding: "10px 24px",
										borderRadius: "30px",
										textDecoration: "none",
									}}
								>
									<i className="fa fa-phone me-2" style={{ fontSize: "20px" }}></i>
									Call Us Now
								</a>
							</div>
						</div>





						{/* RIGHT: Contact Form */}
						<div className="col-md-4 mx-auto">
							<div
								style={{
									backgroundColor: "#fff",
									padding: "30px",
									borderRadius: "10px",
									maxWidth: "360px",
									margin: "0 auto",
								}}
							>
								<h4 style={{ fontWeight: "700", fontSize: "22px", marginBottom: "10px" }}>
									Send Us a Message
								</h4>
								<p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
									Fill out the form below and our team will respond within 24 hours.
								</p>

								<input
									type="text"
									name="FromName"
									placeholder="Name"
									value={maildata.FromName}
									onChange={handleChangeInput}
									style={inputStyle}
								/>

								<input
									type="email"
									name="FromEmail"
									placeholder="Email"
									value={maildata.FromEmail}
									onChange={handleChangeInput}
									style={inputStyle}
								/>

								<input
									type="number"
									name="ContactNo"
									placeholder="Contact Number"
									value={maildata.ContactNo}
									onChange={handleChangeInput}
									style={inputStyle}
								/>

								<select
									name="Language"
									value={maildata.Language}
									onChange={handleChangeInput}
									style={{ ...inputStyle, color: "#333" }}
								>
									<option value="">Select Language</option>
									<option value="English">English</option>
									<option value="Arabic">Arabic</option>
									<option value="Hindi">Hindi</option>
								</select>

								<textarea
									name="Message"
									placeholder="Message"
									value={maildata.Message}
									onChange={handleChangeInput}
									rows="1"
									style={{ ...inputStyle, resize: "none" }}
								></textarea>

								<button
									type="submit"
									onClick={handleSubmit}
									disabled={loading}
									style={{
										backgroundColor: "#FDA94F",
										color: "#fff",
										border: "none",
										width: "100%",
										fontWeight: "600",
										fontSize: "14px",
										padding: "12px",
										borderRadius: "6px",
										marginTop: "10px",
										cursor: "pointer",
									}}
								>
									{loading ? "Submitting..." : "Submit"}
								</button>
							</div>
						</div>



					</div>
				</div>




			</div>
		</div>
		<Faqs />
		<div style={{ paddingBottom: '35px' }}>
			<BlogContact />
		</div>
		<Footer />
	</div>
}

export default Contact

